import React from 'react'

// =============================================================================
// SettingsField — one labelled row in an Agent Studio settings card: a head
// (label plus an optional badge or toggle) above whatever the field renders.
// Shared by LlmSettingsPanel and LanguageSettingsPanel so the two cards on the
// Overview tab keep the same field chrome from one place.
//
// `htmlFor` is optional: a field whose body is a real form control passes it so
// the label binds; a read-only field (the generated language rules) omits it
// and gets a plain span, since a <label> pointing at nothing helps no one.
// =============================================================================
export const SettingsField = ({ label, htmlFor, headExtra, testId, children }) => (
  <div className="voice-agents__llm-field" data-testid={testId}>
    <div className="voice-agents__llm-field-head">
      {htmlFor ? (
        <label className="voice-agents__llm-field-label" htmlFor={htmlFor}>
          {label}
        </label>
      ) : (
        <span className="voice-agents__llm-field-label">{label}</span>
      )}
      {headExtra}
    </div>
    {children}
  </div>
)
